<template>
  <div class="dealers-list">
    <top-bar
      title="Distribuidores"
      :show-add-button="$store.getters['profile/can']('dealers.store')"
      add-button-label="Añadir Distribuidor"
      @addItem="$router.push({name: 'dealers-create'})"
    />
    <scrollable-container>
      <div class="padding-20">
        <ms-grid
          :data="items"
          :columns="columns"
          :options="options"
          :pager="pager"
        />
      </div>
    </scrollable-container>
    <router-view/>
  </div>
</template>

<script>
import DefaultGuards from '@/guards/default.guards'
import DefaultActions from '@/helpers/default-actions'
import TopBar from '@/components/top-bar'
import ScrollableContainer from '@/components/scrollable-container'
import MsGrid from '@/modules/grid/ms-grid'
import StarRating from '@/components/star-rating.vue'
import { mapGetters } from 'vuex'

export default {
  name: 'DealerList',
  components: {
    TopBar,
    ScrollableContainer,
    StarRating,
    MsGrid
  },
  data () {
    return {
      columns: [
        {
          label: 'ID',
          property: 'id',
          align: 'center'
        },
        {
          label: 'Nombre',
          property: 'name',
          link (row) {
            return {
              name: 'dealers-view',
              params: { id: row.id }
            }
          }
        },
        {
          label: 'Creado',
          property: 'createdAt',
          type: 'dateTime'
        }
      ],
      options: {
        selectable: false,
        actions: [
          {
            label: 'Editar',
            icon: 'icon-edit',
            show: () => {
              return this.$store.getters['profile/can']('dealers.update')
            },
            onClick: row => {
              this.$router.push({
                name: 'dealers-edit',
                params: { id: row.id }
              })
            }
          },
          DefaultActions.delete('dealers')
        ]
      }
    }
  },
  computed: {
    ...mapGetters('dealers', {
      items: 'items',
      pager: 'pagination'
    })
  },
  methods: {
    randomStar () {
      return Math.ceil(Math.random() * 5)
    }
  },
  beforeRouteEnter: DefaultGuards.onQuery('dealers', { sort: 'name ASC' }, [
    'name'
  ]),
  beforeRouteUpdate: DefaultGuards.onQuery('dealers', { sort: 'name ASC' }, [
    'name'
  ])
}
</script>

<style scoped>
.dealer-list {
  max-height: 100%;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/views/app/dealers/dealers-list-view.vue